<template>
  <div>
    <CCard class="pb-0">
        <CCardHeader class="pt-0 pb-0">
            <span class="card-header-title">Cổng thông tin điện tử</span>
        </CCardHeader>
            <b-overlay
                :show="state.loading"
                no-wrap
                spinner-variant="success"
                spinner-type="grow"
                rounded="sm"
                opacity="0.8"
                z-index="1000"
            />
            
            <CRow class="p-2" style="min-height:225px">
              <CCol sm="12">
                  <CCard class="p-2">
                  <h5>Bài viết mới:</h5>
                  <span>Trong ngày: <CBadge color="success">{{total_day}}</CBadge> -
                  Trong tháng: <CBadge color="success">{{total_month}}</CBadge> -
                  Trong năm: <CBadge color="success">{{total_year}}</CBadge></span>
                  <hr class="mb-0 mt-2 mb-1">
                  <h5>Mục có lượt xem nhiều nhất tháng:</h5>
                  <div v-if="top_categories.length > 0">
                    <div v-for="(post,index) of top_categories" v-bind:key='index' class="pb-0 mb-2">
                      <span>
                        <b><i class="bx bx-news"></i> {{ post.tenChuyenMuc}}  </b> 
                        <CBadge color="success">({{post.tongSoBaiViet}} bài)</CBadge>&nbsp;
                        <CBadge color="warning">({{post.tongSoLuotView}} lượt)</CBadge>
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    <p>Không có chuyên mục nào có bài viết</p>
                  </div>
                  </CCard>
                </CCol>
                <!-- <CCol sm="4">
                  <CCard class="p-2">
                  <h5>Bài viết mới:</h5>
                  <p>Trong ngày: <CBadge color="success">{{total_day}}</CBadge></p>
                  <p>Trong tháng: <CBadge color="success">{{total_month}}</CBadge></p>
                  <p>Trong năm: <CBadge color="success">{{total_year}}</CBadge></p>
                  </CCard>
                </CCol>
                <CCol sm="8">
                  <CCard class="p-2">
                  <h5>Chuyên mục phổ biến:</h5>
                  <div v-if="top_categories.length > 0">
                    <div v-for="(post,index) of top_categories" v-bind:key='index' class="pb-2">
                      <span>
                        <b><i class="bx bx-news"></i> {{ post.tenChuyenMuc}}  </b> 
                        <CBadge color="success">({{post.tongSoBaiViet}} bài)</CBadge>&nbsp;
                        <CBadge color="warning">({{post.tongSoLuotView}} lượt)</CBadge>
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    <p>Không có chuyên mục nào có bài viết</p>
                  </div>
                  </CCard>
                </CCol> -->
          </CRow>
        <!-- </CCardBody> -->
    </CCard>  
  </div>
</template>

<script>
import ClientFactory from "@/api/ClientFactory";
const PortalApi = ClientFactory.get("portals");

export default {
  components:{},
  created() {
    this.getInfo();
  },
  data(){
    return {
      total_day:0,
      total_month:0,
      total_year:0,
      top_categories:[],
      state:{
          loading:false,
      },
    }
  },
  methods: {
    getInfo: async function(){
      this.state.loading = true;
      const {data} = await PortalApi.getInfo();

      if(data.data!= null) {
        this.top_categories  = data.data.top_categories || 0;
        let total_post = data.data.total_post || {};
        this.total_day = total_post.day || 0;
        this.total_month = total_post.month || 0;
        this.total_year = total_post.year || 0;
      }
      // hide loading
      this.state.loading = false;
    }
  },
  destroyed() {
    // hide loading
    this.state.loading = false;
  }
};
</script>
